const STORAGE_KEY = "scaffoindia_buyer_rfq_draft_v1";
/** Previous key — migrated once on load so enquiry drafts persist across rename */
const LEGACY_STORAGE_KEY = "mrb_buyer_rfq_draft_v1";

function migrateLegacyDraft() {
  if (typeof sessionStorage === "undefined") return;
  try {
    const legacy = sessionStorage.getItem(LEGACY_STORAGE_KEY);
    if (!legacy) return;
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      sessionStorage.setItem(STORAGE_KEY, legacy);
    }
    sessionStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function emptyBuyerRfqDraft() {
  return {
    selectedProducts: {},
    city: "",
    startDate: null,
    requirementType: "rent",
    duration: "",
    customDuration: "",
    phone: "",
    buyerName: "",
    company: "",
  };
}

export function loadBuyerRfqDraft() {
  if (typeof sessionStorage === "undefined") return null;
  migrateLegacyDraft();
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    let startDate = null;
    if (o.startDateIso) {
      const d = new Date(o.startDateIso);
      if (!Number.isNaN(d.getTime())) startDate = d;
    }
    return {
      selectedProducts:
        o.selectedProducts && typeof o.selectedProducts === "object" ? o.selectedProducts : {},
      city: String(o.city ?? ""),
      requirementType: o.requirementType === "buy" ? "buy" : "rent",
      duration: String(o.duration ?? ""),
      customDuration: String(o.customDuration ?? ""),
      phone: String(o.phone ?? ""),
      buyerName: String(o.buyerName ?? ""),
      company: String(o.company ?? ""),
      startDate,
    };
  } catch {
    return null;
  }
}

export function saveBuyerRfqDraft(draft) {
  if (typeof sessionStorage === "undefined") return;
  const { startDate, ...rest } = draft;
  const startDateIso =
    startDate instanceof Date && !Number.isNaN(startDate.getTime())
      ? startDate.toISOString()
      : null;
  const payload = { ...rest, startDateIso };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

/** Read current draft, overlay partial fields, and persist (keeps e.g. Step 2 when home only updates lines). */
export function mergeBuyerRfqDraft(partial) {
  const cur = loadBuyerRfqDraft() || emptyBuyerRfqDraft();
  saveBuyerRfqDraft({ ...cur, ...partial });
}

export function clearBuyerRfqDraft() {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(LEGACY_STORAGE_KEY);
}
